export default {
  automationsLogTimeFrames: [],
  automationLogTimestampStart: 86400,
  automationsLog: [],
  automationsLogFilters: {
    timeFrameTag: null
  }
};